module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/orlando-249b5d9567666ed70c439f00ae6711ec.webp";